'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Popover = _interopDefault(require('@material-ui/core/Popover'));
var utils = require('./utils.js');
var StringsFromArray = require('../StringsFromArray/StringsFromArray.js');
var styledComponents = require('./styled-components.js');

var StringWithPopover = function (props) {
    var strings = props.strings, displayComponents = props.displayComponents;
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var ref = React__default.createRef();
    var onMouseEnter = function (event) {
        if (utils.hasEllipses(ref))
            setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var classes = styledComponents.useStyles();
    return (React__default.createElement(styledComponents.Container, { onMouseEnter: onMouseEnter, onMouseLeave: handleClose, "aria-owns": anchorEl ? 'mouse-over-popover' : undefined, "aria-haspopup": 'true', "aria-describedby": 'text field', "data-testid": 'arrayToStringContainer' },
        displayComponents && (React__default.createElement(styledComponents.DisplayComponentsContainer, null, displayComponents.map(function (component) { return (React__default.createElement("div", { style: { paddingLeft: '5px', position: 'relative', display: 'inline-flex' } }, component)); }))),
        !displayComponents && (React__default.createElement(StringsFromArray, { strings: strings, ref: ref, nowrap: true, addPadding: false })),
        !!anchorEl && (React__default.createElement(Popover, { className: classes.popover, classes: {
                paper: classes.paper,
            }, id: 'mouse-over-popover', open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose, anchorReference: 'anchorEl', anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } },
            React__default.createElement(StringsFromArray, { strings: strings, nowrap: false, addPadding: true })))));
};

module.exports = StringWithPopover;
